"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var DEFAULT = {
  unit: "m\xB2",
  unitAbbrev: "m\xB2",
  formattedValue: value => value
};
var areaUnits = [{
  threshold: 10000,
  unit: 'Hectares',
  unitAbbrev: 'Ha',
  formattedValue: value => parseFloat((value / 10000).toFixed(2))
}];
var getArea = value => {
  var realValue = Number.parseInt("".concat(value), 10);
  var unit = areaUnits.find(each => each.threshold && realValue > each.threshold) || DEFAULT;
  return {
    unit: unit.unit,
    unitAbbrev: unit.unitAbbrev,
    value: unit.formattedValue(realValue)
  };
};
var _default = exports.default = getArea;